import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `dashboard/projections/${path}`;

export function fetchProjectionSummary(payload = {}) {
  return defaultClient.request({
    url: URL('estimate/'),
    method: 'POST',
    payload,
  });
}

export function fetchProjectionZips(payload = {}) {
  return defaultClient.request({
    url: URL('zips/'),
    method: 'POST',
    payload,
  });
}

export function fetchProjectionZipDemographics(payload = {}) {
  return defaultClient.request({
    url: URL('zip-demographics/'),
    method: 'POST',
    payload,
  });
}

export function createProjectionShare(payload = {}) {
  return defaultClient.request({
    url: URL('share/'),
    method: 'POST',
    payload,
  });
}

export function fetchProjectionShare(token) {
  return defaultClient.request({
    url: URL(`share/${token}/`),
    method: 'GET',
    auth: false,
  });
}

export function fetchProjectionShareLatest(clientSlug) {
  return defaultClient.request({
    url: URL(`share/latest/${clientSlug}/`),
    method: 'GET',
  });
}

export function fetchProjectionDraft(clientSlug) {
  return defaultClient.request({
    url: URL(`draft/${clientSlug}/`),
    method: 'GET',
  });
}

export function saveProjectionDraft(clientSlug, payload = {}) {
  return defaultClient.request({
    url: URL(`draft/${clientSlug}/`),
    method: 'POST',
    payload,
  });
}

export function fetchProjectionKpiOverrides(clientSlug, verticals = []) {
  const params = new URLSearchParams();
  if (verticals.length) {
    params.set('verticals', verticals.join(','));
  }
  const query = params.toString();
  return defaultClient.request({
    url: URL(`kpis/${clientSlug}/${query ? `?${query}` : ''}`),
    method: 'GET',
  });
}

export function saveProjectionKpiOverrides(clientSlug, overrides = []) {
  return defaultClient.request({
    url: URL(`kpis/${clientSlug}/`),
    method: 'POST',
    payload: { overrides },
  });
}
